import { storeToRefs } from 'pinia';
import type { ILeagueMatchList } from '@/interface/ILeagueMatchList';
import { useFeatureToggleStore } from '@/stores/featureToggleStore';

export function useEPenaltyCard() {
    const { isEPenaltyCardEnabled, ePenaltyLeagueIds } = storeToRefs(useFeatureToggleStore());

    function isEPenaltyCard(match: ILeagueMatchList) {
        return match.type === 'match'
            && isEPenaltyCardEnabled.value
            && ePenaltyLeagueIds.value.includes(match.leagueId);
    }

    return {
        isEPenaltyCard,
    };
}
